"use strict";

import angular from "angular";

import template from "./one-million-impacts-sidenav.component.html";
import "./one-million-impacts-sidenav.component.scss";

import oneMillionShareDialogTemplate from "../../dialogs/one-million-share/one-million-share-dialog.html";

export class OneMillionImpactsSidenavComponent {
    constructor(
        $scope,
        $mdSidenav,
        toast,
        LoaderService,
        DSNDialogService,
        $state
    ) {
        this.$scope = $scope;
        this.$mdSidenav = $mdSidenav;
        this.toast = toast;
        this.LoaderService = LoaderService;
        this.DSNDialogService = DSNDialogService;
        this.$state = $state;

        this.showMore = false;

        this.content = {
            videoId: "JlAdiaVJ0xg"
        };
    }

    $onInit() {}

    $onChanges() {}

    onShowVideo() {
        if (this.showMore == false) {
            this.showMore = true;
        } else {
            this.showMore = false;
        }
    }

    onShareMission() {
        const statusImpact = !this.impacts?.companiesIdsImpact?.length
            ? 0
            : this.impacts?.companiesIdsImpact?.length;

        this.DSNDialogService.custom({
            controller: "OneMillionShareDialogCtrl as $ctrl",
            clickOutsideToClose: true,
            locals: {
                accountingData: this.accountingData,
                isLevelUp: false,
                status: statusImpact
                    ? this.impacts.currentImpactLevel?.status?.toLowerCase() ||
                      "bronze"
                    : false,
                width: "auto",
                title: "Compartilhe a Missão",
                templateHtml: oneMillionShareDialogTemplate
            },
            after: {
                cancel: () => {},
                hide: () => {}
            }
        });
    }

    onGenerateImpacts() {
        const link = this.$state.href(
            "nucont.accounting.reporting-center.generateds",
            {
                filter: "not-shared"
            }
        );
        window.open(link, "_blank");
    }
}

OneMillionImpactsSidenavComponent.$inject = [
    "$scope",
    "$mdSidenav",
    "toast",
    "LoaderService",
    "DSNDialogService",
    "$state"
];

const name = "oneMillionImpactsSidenavComponent";
const def = {
    bindings: {
        impacts: "<",
        hideButtonGenerated: "<",
        accountingData: "<"
    },
    controller: OneMillionImpactsSidenavComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
